import { styled } from "styled-components";

import { ReactComponent as KaggleIcon } from "../../assets/icons/kaggle.svg";
import { ReactComponent as GitIcon } from "../../assets/icons/git.svg";
import { ReactComponent as LinkedinIcon } from "../../assets/icons/linkedin.svg";
import { ReactComponent as HFIcon } from "../../assets/icons/hf-logo.svg";

const Socials = () => {
  return (
    <StyledSocials>
      <ul>
        <li>
          <a
            href="https://huggingface.co/GKarol"
            target="_blank"
            rel="noreferrer"
          >
            <HFIcon />
          </a>
        </li>
        <li>
          <a
            href="https://www.kaggle.com/karolgu"
            target="_blank"
            rel="noreferrer"
          >
            <KaggleIcon />
          </a>
        </li>
        <li>
          <a
            href="https://github.com/KarolG99"
            target="_blank"
            rel="noreferrer"
          >
            <GitIcon />
          </a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/in/karol-gucwa-0a3104226/"
            target="_blank"
            rel="noreferrer"
          >
            <LinkedinIcon />
          </a>
        </li>
      </ul>
    </StyledSocials>
  );
};

const StyledSocials = styled.div`
  position: absolute;
  left: 30px;

  ul {
    display: flex;
    flex-direction: column;
    gap: 15px;
    list-style: none;
    margin: 0;
    padding: 0;
    opacity: 0.4;
  }

  @media (max-width: 1099px) {
    display: none;
  }
`;

export default Socials;
